import { render, staticRenderFns } from "./DomainSuperGroups.vue?vue&type=template&id=10baa524&scoped=true"
import script from "./DomainSuperGroups.vue?vue&type=script&lang=js"
export * from "./DomainSuperGroups.vue?vue&type=script&lang=js"
import style0 from "./DomainSuperGroups.vue?vue&type=style&index=0&id=10baa524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10baa524",
  null
  
)

export default component.exports